const data = [
    {
        id: 1,
        heading: "What services does KilonzoCorp provide?",
        content: "KilonzoCorp specializes in data annotation services to support AI and machine learning models. Our offerings include Image & Video Annotation, Text Annotation, Audio Annotation, and 3D Point Cloud Annotation.",
    },
    {
        id: 2,
        heading: "How can I get started with your services?",
        content: "To begin, visit our Contact Us page and fill out the form. Our team will respond promptly to discuss your project requirements and guide you through the onboarding process.",
    },
    {
        id: 3,
        heading: "How do you ensure the accuracy of your annotations?",
        content: "We implement strict quality control processes, including multi-stage reviews and validation. Our experienced team uses advanced tools and manual oversight to ensure high accuracy, vital for training reliable AI models.",
    },
    {
        id: 4,
        heading: "What industries do you serve?",
        content: "We work with a wide range of industries, including healthcare, autonomous driving, agriculture, and retail. Our data annotation services support various AI use cases, from diagnosing medical conditions to improving the safety of autonomous vehicles.",
    },
    {
        id: 5,
        heading: "How do you protect my data during the annotation process?",
        content: "We prioritize data security with industry-standard encryption and access control measures. Our team follows strict confidentiality protocols, and we are willing to sign non-disclosure agreements (NDAs) to protect your intellectual property.",
    },
    {
        id: 6,
        heading: "What are your pricing options?", 
        content: "We offer flexible pricing plans designed to scale with your data annotation needs, from essential services to comprehensive, enterprise-level solutions. For detailed information, please visit our Pricing page.",
    },
    {
        id: 7,
        heading: "How can I contact KilonzoCorp for further inquiries?",
        content: "You can reach us through the Contact Us page on our website. Alternatively, you can visit our office at Kathaayoni Estate, Machakos-Kitui Road, Machakos, Kenya.",
    },
];

export default data;
